import {Injectable} from "@angular/core";
import {OrderCrudComponent} from "../../../crystal-clear/support/order-crud/order-crud.component";
import {Order} from "../../../model/clearing/order";
import {resolveFieldTypes} from "../../../utils/object-reflection";
import {TableColumnUtils} from "../../../utils/table-column-utils";
import {AccountDefinition} from "../../../model/customer/account-definition";
import {TableColumnConfig} from "../../../model/api/table-column-config";
import {Trade} from "../../../model/clearing/trade";
import CallPut = Trade.CallPut;

@Injectable({providedIn: 'root'})
export class SupportOrderTableConfigService {

  private readonly fieldTypes = resolveFieldTypes<Order>({
    side: 'enum',
    state: 'enum',
    callPut: 'enum',

    executionDate: 'date',
    businessDate: 'date',
    clearingDate: 'date',

    creationDate: 'datetime',
    modificationDate: 'datetime',

    clearings: 'array',
    clearingInfo: 'object',

    avgPriceManaged: 'boolean',
    isChecked: 'boolean',
    isDisabled: 'boolean',
    giveIn: 'boolean',
    giveUp: 'boolean',
    jobOut: 'boolean',
    forceClear: 'boolean',
    brokerageOverridden: 'boolean',
    alreadyPaidElsewhere: 'boolean',
    unknownAccount: 'boolean',
    manualInvoiceRemoved: 'boolean',
  });

  loadConfig(component: OrderCrudComponent) {

    const tableConfig: TableColumnConfig[] = (Object.keys(component.newRecord ?? {}) as Array<keyof Order>)
      .filter(field => !this.isExcluded(field))
      .map(field => {
        const type = this.fieldTypes[field];

        const column = TableColumnUtils.buildColumn<Order>(
          field,
          type,
          this.orderOverrides(field, type)
        );

        OrderTableFilters.apply(column, field);
        return column;
      });

    tableConfig.forEach(columnConfig => {
      if (columnConfig.field === 'id'
        ||columnConfig.field === 'parentId') {
        columnConfig.width = 250;
      }
    })

    return tableConfig;
  }

  private orderOverrides(field: keyof Order, type: any) {
    if (field === 'account') {
      return {
        mapId: (record: Order) => record.account?.name
      };
    }

    if (type === 'boolean') {
      return {
        icon: TableColumnUtils.booleanIcon<Order>(field),
        mapId: TableColumnUtils.booleanMapId()
      };
    }

    return {};
  }

  private isExcluded(field: keyof Order): boolean {
    return [
      'clearings',
      'clearingInfo'
    ].includes(field as string);
  }
}


export class OrderTableFilters {

  static apply(column: TableColumnConfig, field: keyof Order): void {

    const f = field.toLowerCase();

    const filterType =
      ['businessdate', 'clearingdate', 'creationdate', 'executiondate'].includes(f) ? 'date' :
        ['volume', 'price', 'avgprice', 'avgrndprice', 'avgpriceresidual', 'overrideavgprice', 'strike', 'strategymissing'].includes(f) ? 'numeric' :
          ['side', 'openclose'].includes(f) ? undefined :
            'text';

    column.filterConfig = {
      type: filterType,
      matchMode: filterType === 'text' ? 'contains' : undefined,
      values: undefined
    };

    if (field === 'side') {
      column.filterConfig.values = Object.values(Trade.Side);
      column.filterConfig.matchMode = 'equals';
    } else if (field === 'openClose') {
      column.filterConfig.values = Object.values(AccountDefinition.OpenClose);
      column.filterConfig.matchMode = 'in';
    } else if (field === 'callPut') {
      column.filterConfig.values = Object.values(CallPut);
      column.filterConfig.matchMode = 'in';
    }
  }
}
